export default "__VITE_ASSET__BmDllNy8__"